export interface AiFieldValue<T = string | string[] | null> {
  value: T;
  confidence: number;
}

export type AiStringField = AiFieldValue<string | null>;
export type AiTagsField = AiFieldValue<string[] | null>;

export interface ResearchMetadata {
  title: AiStringField;
  authors: AiTagsField;
  correspondingAuthor: AiStringField;
  journalName: AiStringField;
  conferenceName: AiStringField;
  publisher: AiStringField;
  institution: AiStringField;
  department: AiStringField;
  abstract: AiStringField;
  keywords: AiTagsField;
  doi: AiStringField;
  isbn: AiStringField;
  issn: AiStringField;
  publicationYear: AiStringField;
  volume: AiStringField;
  issue: AiStringField;
  pageNumbers: AiStringField;
  citationFormat: AiStringField;
  fundingAgency: AiStringField;
}

export interface DocumentAnalysisResult {
  documentType: AiStringField;
  name: AiStringField;
  description: AiStringField;
  categoryId: AiStringField;
  subcategory: AiStringField;
  tags: AiTagsField;
  eventName: AiStringField;
  eventType: AiStringField;
  recognition: AiStringField;
  recognitionDetail: AiStringField;
  organizer: AiStringField;
  organizerType: AiStringField;
  eventDate: AiStringField;
  issueDate: AiStringField;
  expiryDate: AiStringField;
  publicationDate: AiStringField;
  location: AiStringField;
  achievementType: AiStringField;
  awardName: AiStringField;
  rank: AiStringField;
  level: AiStringField;
  subjectArea: AiStringField;
  competitionName: AiStringField;
  research: ResearchMetadata;
  overallConfidence: number;
  model?: string;
  version?: string;
}

export const LOW_CONFIDENCE_THRESHOLD = 80;

export function isLowConfidence(confidence: number): boolean {
  return confidence > 0 && confidence < LOW_CONFIDENCE_THRESHOLD;
}

export function formatConfidence(confidence: number): string {
  const normalized = confidence <= 1 && confidence > 0 ? confidence * 100 : confidence;
  return `${Math.round(normalized)}%`;
}

export function fieldDisplayValue(field: AiFieldValue<string | string[] | null>): string {
  if (field.value == null) return '';
  if (Array.isArray(field.value)) return field.value.join(', ');
  return String(field.value);
}
